const gridAppsQueryKeys={getGridapps:organizationId=>{return['gridapps',organizationId];}};export default gridAppsQueryKeys;